var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AlertModal from "../Modal/AlertModal";
import "./Picker.css";
import TimePicker from "./TimePicker";
var Picker = function (_a) {
    var title = _a.title, cancelText = _a.cancelText, continueText = _a.continueText, show = _a.show, setShow = _a.setShow, onContinue = _a.onContinue, withTime = _a.withTime, hour = _a.hour, setHour = _a.setHour, minute = _a.minute, setMinute = _a.setMinute, children = _a.children;
    return (_jsx(AlertModal, __assign({ type: "info", loading: false, show: show, onClose: function () { return setShow(false); }, onContinue: onContinue, title: title, cancelText: cancelText, continueText: continueText, hideIcon: true }, { children: _jsxs("div", __assign({ className: "flex flex-col gap-6" }, { children: [children, withTime &&
                    _jsx(TimePicker, { withTime: withTime, hour: hour, setHour: setHour, minute: minute, setMinute: setMinute })] })) })));
};
export default Picker;
